import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SplitNoSidebarComponent } from './blog-list-creative/split-no-sidebar/split-no-sidebar.component';
import { DetailNoSidebarComponent } from './blog-detail/detail-no-sidebar/detail-no-sidebar.component';
import { BigpostSplitComponent } from './blog-mix-layout/bigpost-split/bigpost-split.component';
import { ColumnRightSidebarComponent } from '@blog/column-right-sidebar/column-right-sidebar.component';


const routes: Routes = [
  { path: '', component: ColumnRightSidebarComponent },
  { path: 'blog', component: ColumnRightSidebarComponent },
  {
    path: 'blog-detail/:id',
    component: DetailNoSidebarComponent,
  },
];



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogRoutingModule { }
